<template>
  <div class="dialog-email">
    <el-dialog :title="isAdd?'新增邮箱地址':'修改邮箱地址'"
      :visible.sync="emailDialogVisible"
      :close-on-click-modal="false"
      @close="cancleDialog"
      width="560px" >
      <div>
        <el-form :model="emailDialogForm" label-width="150px" :rules="rules" ref="emailForm">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="emailDialogForm.email" placeholder="请输入邮箱" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item label="" prop="defaultFlag">
            <el-checkbox v-model="emailDialogForm.defaultFlag" :true-label="1" :false-label="0">设置为默认邮箱</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="submit" v-loading="loading" :disabled="loading" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const checkEmail = (rule, value, callback) => {
    const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
    if (!value) {
      return callback(new Error('请输入邮箱'))
    }
    if (mailReg.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的邮箱格式'))
    }
  }
export default {
  props: {
    isAdd: {
      type: Boolean,
      default: false
    },
    emailDialogVisibleProps: {
      type: Boolean,
      default: false
    },
    emailRowInfoProps: {
      type: Object,
      default: {}
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    emailDialogVisible: {
      get() {
        return this.emailDialogVisibleProps;
      },
      set() {}
    }
  },
  watch: {
    'emailRowInfoProps': {
      handler(val) {
        this.emailDialogForm = JSON.parse(JSON.stringify(val));
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      emailDialogForm: {
        email: '',
        defaultFlag: 0, // 0否 1是
      },
      loading: false,
      rules: {
        email: [{required: true, validator: checkEmail, trigger: 'blur'}],
      },
    }
  },
  mounted() {},
  methods: {
    cancleDialog() {
      this.$refs.emailForm.resetFields();
      this.$emit('cancleEmailDialog')
    },
    submit() {
      this.$refs.emailForm.validate(valid => {
        if(valid) {
          let url = this.isAdd?'/uac/email/add' :'/uac/email/update';
          let params = {
            email: this.emailDialogForm.email,
            defaultFlag: this.emailDialogForm.defaultFlag, // 0否 1是
            userId: this.user.userId
          }
          if(!this.isAdd) params.id = this.emailDialogForm.id;
          this.loading = true;
          this.postRequestJson(url, params).then(res => {
            this.loading = false;
            if(res.status === 200) {
              if(res.data.code === 1000) {
                 this.$message.success('保存成功！');
                this.cancleDialog();
                this.$refs.emailForm.resetFields();
              } else {
                this.$message.error(res.data.message);
              }
            }
          })
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
 .dialog-email{
    .pxy-input {
      width: 220px;
    }
  }
 </style>
